module.exports = {"title":"404 | GoGoVan 台灣","404_title":"","404_body":["ᒥ你會出現在這裡，一定有原因的。","要活得有價值，就請好好把握自己的存在。ᒧ"],"404_sub":"五月天 - 阿信","404_links_title":"或者試試這些鏈接：","404_links_button_link_title":"回首頁"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/tw/setting/404/locale.json
// module id = 726
// module chunks = 0 1 2 3 4 5